import { render, staticRenderFns } from "./SplitterContainer.vue?vue&type=template&id=4b44cebd&scoped=true"
import script from "./SplitterContainer.vue?vue&type=script&lang=js"
export * from "./SplitterContainer.vue?vue&type=script&lang=js"
import style0 from "./SplitterContainer.vue?vue&type=style&index=0&id=4b44cebd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b44cebd",
  null
  
)

export default component.exports